// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { NewsResult } from "@bg/App/Handlers/News/LoadNews";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { PageProps } from "@insite/mobius/Page";
import { Draft } from "immer";

export type NewsState = {
    isLoading: boolean;
    noData: boolean;
    pages: PageProps[];
    pagination: any;
};

const initialState: NewsState = {
    isLoading: false,
    noData: true,
    pages: [],
    pagination: undefined,
};

const newsData = createTypedReducerWithImmer(initialState, {
    "CustomNews/BeginLoadData": (draft: Draft<NewsState>) => {
        draft.isLoading = true;
    },
    "CustomNews/CompletedLoadingData": (draft: Draft<NewsState>, action: { result: NewsResult }) => {
        draft.isLoading = false;
        draft.noData = false;
        draft.pages = action.result.pages as any;
        draft.pagination = action.result.pagination;
    },
});

(reducers as any).newsData = newsData;

type customNewsReducer = {
    newsData: typeof newsData;
};

export type newsData = {
    newsData: NewsState;
};

export type newsDataActions = Parameters<customNewsReducer[keyof customNewsReducer]>[1] | AnyAction;
